import { media } from 'src/common/styles/breakpoints';
import { css } from 'styled-components';
import tenantTypography from '@tenant/styles/typography';

export type TextDecoration = 'default' | 'underline';
export type TextVariant = 'default' | 'headers';

export interface TypographyBase {
  decoration?: TextDecoration;
  variant?: TextVariant;
}

const fontFamilyDefault = tenantTypography.fontFamily;

export const typography = {
  fontFamilyDefault,
} as const;

export const heading = {
  h1: css`
    font-style: normal;
    font-weight: normal;
    font-family: ${typography.fontFamilyDefault};

    font-size: 1.5rem;
    line-height: 1.5;

    ${media.w.min.px768(css`
      font-size: 2.3125rem;
      line-height: 1.5;
    `)}
  `,
};

export const typographyBaseCss = css<TypographyBase>`
  font-family: ${({ variant }) =>
    'headers' === variant
      ? typography.fontFamilyDefault
      : typography.fontFamilyDefault};
`;

export const textUnderlineEffect = css<TypographyBase>`
  padding-top: 0.1875rem;
  position: relative;
  text-decoration: ${({ decoration }) =>
    'underline' === decoration ? 'underline' : 'none'};

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  &:active {
    color: currentColor;
  }
`;
